<div class="row">
  <div class="col-md-6" *ngFor="let item of createRange(patientdata.Nocicle); let i = index">
    <div class="card" *ngIf="item">
      <div class="card-header text-center" ><span i18n="@@cycleHeader">Cycle en</span> {{ (patientdata.Cicle + i) }}</div>
      <div class="card-body">
        <app-dvmp [treatmentcomponnetindex]="i" [patientdata]="{data: patientdata, currentCycle: (patientdata.Cicle + i) }"></app-dvmp>
      </div>
    </div>
  </div>
</div>

<div class="col-sm-12" >
  <button i18n="@@seeCalendarBtn" routerLink="/calendar" class="btn btn-primary calculate"  routerLinkActive="active">See calendar btn en</button>
</div>

